import { queryOptions } from "@tanstack/react-query";

import { ContactType, PushType } from "@seneca/notifications-service-types";

import { getClient } from "services";

import { PreferencesType } from "./types";
import getNotificationPreferenceTypeServiceName from "./utils/getNotificationPreferenceTypeServiceName";
import getPreferencesQueryKey from "./utils/getPreferencesQueryKey";

type Type<T> = T extends "push" ? PushType : ContactType;

export default function fetchPreferencesQueryOptions<T extends PreferencesType>(
  type: T
) {
  const client = getClient("notificationsService");

  const typeName = getNotificationPreferenceTypeServiceName(type);
  const QueryKey = getPreferencesQueryKey(type);

  async function fetchData(type: any) {
    return client.fetchMyNotificationPreferences<Type<T>>({ type });
  }

  return queryOptions({
    queryKey: [QueryKey],
    queryFn: () => fetchData(typeName)
  });
}
